import script from "./SignaturePadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignaturePadForm.vue?vue&type=script&setup=true&lang=js"

import "./SignaturePadForm.vue?vue&type=style&index=0&id=3cc08ea9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc08ea9"]])

export default __exports__